// React
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Locales
import translate from 'locales/i18n';
// Actions
import SignAction from 'actions/SignAction';
import LoggedUserAction from 'actions/LoggedUserAction';
import AlertAction from 'actions/AlertAction';
// Material components
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
// Flag Library
import { countryToFlag } from 'components/dialogs/proxy/DialogEditProxyUtils';
// Languages file
import Languages from 'locales/Language';
//Style
import styles from 'components/appbar/Appbar.style';
import withStyles from '@mui/styles/withStyles';

class Appbar extends React.PureComponent {

    state = {
        languageMenu: null,
        languageMenuOpened: false,
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
        sidebarOpen: PropTypes.bool,
        toogleSidebar: PropTypes.func
    };

    tradCodeToFlagCode = () => {
        const currentTradCode = translate.getCurrentLanguage();
        let currentFlagCode = '';
        let loop = true;

        for (let i = 0; loop === true && i < Object.keys(Languages).length; i += 1) {
            if (Languages[i].tradCode === currentTradCode) {
                currentFlagCode = Languages[i].flagCode;
                loop = false;
            }
        }

        return currentFlagCode;
    };

    handleLanguageMenuClick = event => {
        this.setState({
            languageMenu: event.currentTarget,
            languageMenuOpened: true
        });
    };

    handleLanguageMenuClose = () => {
        this.setState({
            languageMenu: null,
            languageMenuOpened: false
        });
    };

    handleLanguageSelection = (language) => {
        if (language !== translate.getCurrentLanguage) {
            translate.setLanguage(language);
            LoggedUserAction.changeCurrentLanguage(language);
        }
        this.handleLanguageMenuClose();
    };

    logout = () => {
        SignAction.logout();
        AlertAction.open('success', translate.i18n('DISCONNECTED'), 'top-right');
    };

    renderLanguageMenu() {

        return Languages.map((input, key) =>
            <MenuItem key={key} onClick={() => this.handleLanguageSelection(input.tradCode)}>
                {countryToFlag(input.flagCode)}
                {input.name}
            </MenuItem>
        );
    }

    render() {
        const { classes } = this.props;
        const { languageMenu, languageMenuOpened } = this.state;

        return (
            <AppBar
                position='absolute'
                className={classes.appbar}
            ><Toolbar className={classes.toolbar}>
                    <IconButton
                        color='inherit'
                        aria-label='Open drawer'
                        onClick={this.props.toogleSidebar}
                        className={classes.menuButton}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant='h5' color='inherit' noWrap className={classNames(classes.typography, this.props.sidebarOpen && classes.hideMobile)}>
                        Back<span className={classes.office}>Office </span>
                        <Typography color='inherit' noWrap className={classNames(classes.typographySubtitle, this.props.sidebarOpen && classes.hideMobile)}>
                            PriceComparator
                        </Typography>
                    </Typography>
                    {process.env.REACT_APP_ENV !== 'production' ? <span className={classes.envLabel}>ATTENTION VOUS ÊTES EN TEST!</span> : null}
                    <Tooltip title={translate.i18n('LANGUAGE')} placement='bottom'>
                        <IconButton
                            className={classNames(this.props.sidebarOpen && classes.hideMobile)}
                            aria-haspopup='true'
                            color='inherit'
                            aria-owns={languageMenu ? 'simple-menu' : null}
                            onClick={this.handleLanguageMenuClick}>
                            <Badge
                                badgeContent={this.tradCodeToFlagCode() ? countryToFlag(this.tradCodeToFlagCode()) : ''}>
                                <Icon>language</Icon>
                            </Badge>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        id='simple-menu'
                        anchorEl={languageMenu}
                        open={languageMenuOpened}
                        onClose={this.handleLanguageMenuClose}
                    >
                        {this.renderLanguageMenu()}
                    </Menu>
                    <Tooltip title={translate.i18n('LOGOUT')} placement='bottom'>
                        <IconButton
                            className={classNames(this.props.sidebarOpen && classes.hideMobile)}
                            aria-haspopup='true'
                            onClick={this.logout}
                            color='inherit'>
                            <Icon>exit_to_app</Icon>
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(styles)(Appbar);
